export function createReducer(initialState, handlers) {
  return function reducer(state = initialState, action) {
    // eslint-disable-next-line no-prototype-builtins
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  };
}

/**
 * @param {Object<any>} game
 * @param is_hidden
 * @return {Object}
 * @constructor
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AddIsHiddenToGame = (game, is_hidden = false) => {
  if (!game.enabled) {
    return {
      ...game,
      is_hidden: true,
    };
  }

  return {
    ...game,
    is_hidden,
  };
};

/**
 * @param {number} id
 * @param {number} correctID
 * @return {boolean}
 * @description Check is incorrect ID?!
 */
export const isWrongID = (id, correctID) => id !== -1 && id !== correctID;

/**
 * @param {Object} obj
 * @param {string} key
 * @param {(string, null)} subKey
 * @description Increase object value by key
 */
export const incObjectValue = (obj, key, subKey = null) => {
  const num = (obj[key] ? (subKey ? obj[key][subKey] : obj[key]) || 0 : 0) + 1;
  return subKey
    ? obj[key]
      ? (obj[key][subKey] = num)
      : (obj[key] = { [subKey]: num })
    : (obj[key] = num);
};

/**
 * @param {Array<Object>} tags
 * @return {Array<Object>}
 * @description Sort tags by priority.
 */
export const sortTags = (tags) => {
  return Array.isArray(tags)
    ? tags.sort((a, b) => {
        return (b.priority || 0) - (a.priority || 0);
      })
    : tags;
};

/**
 * @param {Array<Object>} arr
 * @param {number} id
 * @return {Object}
 * @description Get array element by id.
 */
export const getItemById = (arr, id) =>
  Array.isArray(arr) ? arr?.find((item) => item.id === id) : {};
